import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Srodstvo } from './srodstvo';

@Component({
  selector: 'yt-srodstvo-modal-update',
  templateUrl: './srodstvo-modal-update.component.html'
})
export class SrodstvoModalUpdateComponent
 extends BaseModalUpdateComponent<Srodstvo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Srodstvo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
